import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  color: string;
  icon: string;
  size: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomIcon',
  props: {
    color: { default: 'warning' },
    icon: { default: 'mdi-alert-circle' },
    size: { default: 'small' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_component_v_icon, {
    color: props.color,
    icon: props.icon,
    size: props.size
  }, null, 8, ["color", "icon", "size"]))
}
}

})